module.exports = __webpack_public_path__ + "images/engagement-survey-logo.png";